const output = {
  metadataKey: ["required", "trim", "string"],
  metadataValue: ["required", "trim", "string"],
};

export default output;
